import { View } from 'react-native';

import { Bounded } from '@/components/ui/Bounded';
import { useSyncStatus } from '@/lib/sync-status';

import { SyncStatusBanner } from './SyncStatusBanner';
import { type SyncStatusAreaProps } from './syncStatusArea.types';

/**
 * Web has no pull gesture, so there is no peek: the banner is pinned below the
 * header only while something needs attention (state !== 'synced'), matching
 * native's pinned rule. The synced/freshness states never render on web.
 */
export function SyncStatusArea({ children }: SyncStatusAreaProps) {
  const { state, pending, lastSyncedAt } = useSyncStatus();
  return (
    <View className="flex-1">
      {state !== 'synced' ? (
        <Bounded className="px-5 pb-2" accessibilityLiveRegion="polite">
          <SyncStatusBanner state={state} pending={pending} lastSyncedAt={lastSyncedAt} />
        </Bounded>
      ) : null}
      {children}
    </View>
  );
}
